import { useEffect, useState } from "react";
import { X } from "lucide-react";
import api from "@/lib/api";

const IMG_URL = `${process.env.REACT_APP_BACKEND_URL}/api/news-popup/image`;

export default function NewsPopup() {
  const [popup, setPopup] = useState(null);

  useEffect(() => {
    api.get("/news-popup").then(({ data }) => {
      if (!data?.enabled || !data?.image_id) return;
      const seen = sessionStorage.getItem("mmx_news_seen");
      if (seen === data.image_id) return;
      setPopup(data);
    }).catch(() => {});
  }, []);

  const close = () => {
    if (popup?.image_id) sessionStorage.setItem("mmx_news_seen", popup.image_id);
    setPopup(null);
  };

  if (!popup) return null;

  return (
    <div
      data-testid="news-popup-overlay"
      className="fixed inset-0 z-[100] grid place-items-center bg-black/80 backdrop-blur-sm p-4"
      onClick={close}
    >
      <div
        className="relative max-w-2xl w-full rounded-2xl overflow-hidden border border-amber-500/30 shadow-[0_0_60px_rgba(245,158,11,0.15)]"
        onClick={(e) => e.stopPropagation()}
        data-testid="news-popup-card"
      >
        <button
          data-testid="news-popup-close"
          onClick={close}
          className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-black/60 border border-white/20 grid place-items-center text-white hover:bg-black/80 transition-all"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>
        <img
          src={`${IMG_URL}?v=${popup.image_id}`}
          alt="Announcement"
          className="w-full h-auto block"
          data-testid="news-popup-image"
        />
      </div>
    </div>
  );
}
